var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublishNowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7778 7.5H12.2222C9.89035 7.5 8 9.39035 8 11.7222V27.2778C8 29.6096 9.89035 31.5 12.2222 31.5H27.7778C30.1096 31.5 32 29.6096 32 27.2778V11.7222C32 9.39035 30.1096 7.5 27.7778 7.5ZM12.2222 5.5H27.7778C31.2142 5.5 34 8.28578 34 11.7222V27.2778C34 30.7142 31.2142 33.5 27.7778 33.5H12.2222C8.78578 33.5 6 30.7142 6 27.2778V11.7222C6 8.28578 8.78578 5.5 12.2222 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3508 15.7705C25.7537 16.1482 25.7741 16.781 25.3964 17.1839L19.563 23.4062C19.1924 23.8015 18.5742 23.8297 18.1691 23.4696L14.6691 20.3585C14.2564 19.9916 14.2192 19.3595 14.5861 18.9468C14.953 18.534 15.5851 18.4968 15.9979 18.8637L18.77 21.3278L23.9373 15.8161C24.315 15.4131 24.9479 15.3927 25.3508 15.7705Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishNowIcon);
export default __webpack_public_path__ + "static/media/publish-now-icon.53c52213.svg";
export { ForwardRef as ReactComponent };